export const teams = {
  items: [
    {
      id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
      name: 'Team Revenue',
      description: 'Team Revenue of Sales Department',
      departments: [
        {
          id: 'bd42d86f-d341-4d80-a1b7-5500c008be2f',
          name: 'Sales Department',
        },
      ],
      employeeCount: 12,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:45:27Z',
    },
    {
      id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
      name: 'Team Outreach',
      description: 'Team Outreach of Sales Department',
      departments: [
        {
          id: 'bd42d86f-d341-4d80-a1b7-5500c008be2f',
          name: 'Sales Department',
        },
      ],
      employeeCount: 7,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:51:22Z',
    },
    {
      id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
      name: 'Team CRM',
      description: 'Team CRM of Sales Department',
      departments: [
        {
          id: 'bd42d86f-d341-4d80-a1b7-5500c008be2f',
          name: 'Sales Department',
        },
      ],
      employeeCount: 8,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:44:49Z',
    },
    {
      id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
      name: 'Frontend Team',
      description: 'Frontend Team of Development Department',
      departments: [
        {
          id: 'ec639679-fff8-49d1-b863-b389f8a0e123',
          name: 'Development Department',
        },
      ],
      employeeCount: 16,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:45:48Z',
    },
    {
      id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
      name: 'Backend Team',
      description: 'Backend Team of Development Department',
      departments: [
        {
          id: 'ec639679-fff8-49d1-b863-b389f8a0e123',
          name: 'Development Department',
        },
      ],
      employeeCount: 21,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:54:34Z',
    },
    {
      id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
      name: 'DevOps Team',
      description: 'DevOps Team of Development Department',
      departments: [
        {
          id: 'ec639679-fff8-49d1-b863-b389f8a0e123',
          name: 'Development Department',
        },
      ],
      employeeCount: 12,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:56:44Z',
    },
    {
      id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
      name: 'UI Team',
      description: 'UI Team of Design Department',
      departments: [
        {
          id: '71ef5c0e-b3a6-4709-b2fc-1094477527c3',
          name: 'Design Department',
        },
      ],
      employeeCount: 9,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:50:09Z',
    },
    {
      id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
      name: 'UX Team',
      description: 'UX Team of Design Department',
      departments: [
        {
          id: '71ef5c0e-b3a6-4709-b2fc-1094477527c3',
          name: 'Design Department',
        },
      ],
      employeeCount: 23,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:56:51Z',
    },
    {
      id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
      name: 'Content Team',
      description: 'Content Team of Marketing Department',
      departments: [
        {
          id: 'c72ace04-8daa-46a8-9d4f-052bb5d642d0',
          name: 'Marketing Department',
        },
      ],
      employeeCount: 15,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:54:24Z',
    },
    {
      id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
      name: 'Social Media Team',
      description: 'Social Media Team of Marketing Department',
      departments: [
        {
          id: 'c72ace04-8daa-46a8-9d4f-052bb5d642d0',
          name: 'Marketing Department',
        },
      ],
      employeeCount: 18,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:49:17Z',
    },
    {
      id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
      name: 'SEO Team',
      description: 'SEO Team of Marketing Department',
      departments: [
        {
          id: 'c72ace04-8daa-46a8-9d4f-052bb5d642d0',
          name: 'Marketing Department',
        },
      ],
      employeeCount: 8,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T16:00:19Z',
    },
    {
      id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
      name: 'Growth Team',
      description: 'Growth Team of Marketing Department',
      departments: [
        {
          id: 'c72ace04-8daa-46a8-9d4f-052bb5d642d0',
          name: 'Marketing Department',
        },
      ],
      employeeCount: 20,
      companyId: 'c98775e0-ff20-4e5f-900e-caeea6f99dc6',
      createdAt: '2025-04-29T15:48:49Z',
    },
  ],
  meta: {
    page: 1,
    limit: 10,
    total: 12,
    totalPages: 2,
  },
};
